export default [
    'None Selected',
    'Yes, ASD Operating',
    'Yes, ASD Not Operating',
    'Yes, Passive System',
    'No',
  ];
  


// WEBPACK FOOTER //
// src/constants/mitigationSystemPresent.js